module.exports = __webpack_public_path__ + "img/coinbankB27.45021b37.jpg";